export default "__VITE_ASSET__SBeI$h24__"